import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import moment from 'moment'
import Valid from '../../functions/validation'
import Alert from "../../functions/alert"
import CONS from "../../constants"
import InputDateTime from '../../components/input-date-time'
import Format from '../../functions/format'
import Log from "../../functions/log"

function Modal(props) {
    const [data, setData] = useState(props.data)

    const handleCreate = () => {
        Log.save(CONS.API_CLASS, { ...data, date: Format.convertDateToISOString(moment(data.date, "DD/MM/YYYY").format('YYYY-MM-DD')) })
        axios.put(CONS.API_CLASS, { ...data, date: Format.convertDateToISOString(moment(data.date, "DD/MM/YYYY").format('YYYY-MM-DD')) }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': CONS.AUTH_PREFIX + localStorage.getItem('token')
            }
        }).then((response) => {
            if (response.data.status === 200) {
                Alert.showMsg("บันทึกเรียบร้อย")
                var modal = document.getElementById(props.id)
                modal.classList.remove(`show`)
                var backdrop = document.getElementById(`modal-backdrop`)
                backdrop.classList.remove(`show`)
                document.body.classList.remove(`modal-open`)
                document.body.style.overflow = null
                document.body.style.paddingRight = null
                setTimeout(() => {
                    if (props.callBack !== undefined) props.callBack()
                    ReactDOM.unmountComponentAtNode(document.getElementById('modal-root'))
                    backdrop.parentNode.removeChild(backdrop)
                }, 300)
            } else {
                Alert.showMsg("เกิดข้อผิดพลาด บันทึกไม่สำเร็จ", "danger")
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                if (error.response.status === 401) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('role')
                    localStorage.removeItem('name')
                    props.history.push(CONS.URL_LINK + '/login?auth=false')
                }
            }
        })
    }

    const handleUpdate = () => {
        Log.save(CONS.API_CLASS, { ...data, date: Format.convertDateToISOString(moment(data.date, "DD/MM/YYYY").format('YYYY-MM-DD')) })
        axios.post(CONS.API_CLASS, { ...data, date: Format.convertDateToISOString(moment(data.date, "DD/MM/YYYY").format('YYYY-MM-DD')) }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': CONS.AUTH_PREFIX + localStorage.getItem('token')
            }
        }).then((response) => {
            if (response.data.status === 200) {
                Alert.showMsg("บันทึกเรียบร้อย")
                var modal = document.getElementById(props.id)
                modal.classList.remove(`show`)
                var backdrop = document.getElementById(`modal-backdrop`)
                backdrop.classList.remove(`show`)
                document.body.classList.remove(`modal-open`)
                document.body.style.overflow = null
                document.body.style.paddingRight = null
                setTimeout(() => {
                    if (props.callBack !== undefined) props.callBack()
                    ReactDOM.unmountComponentAtNode(document.getElementById('modal-root'))
                    backdrop.parentNode.removeChild(backdrop)
                }, 300)
            } else {
                Alert.showMsg("เกิดข้อผิดพลาด บันทึกไม่สำเร็จ", "danger")
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                if (error.response.status === 401) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('role')
                    localStorage.removeItem('name')
                    props.history.push(CONS.URL_LINK + '/login?auth=false')
                }
            }
        })
    }

    const handleSubmit = () => {
        var valid = Valid.form("form-data")
        if (valid) {
            if (data.id) {
                handleUpdate()
            } else {
                handleCreate()
            }
        } else {
            Alert.showMsg("กรุณากรอกข้อมูลให้ครบถ้วน", "danger")
        }
    }

    const handleClose = () => {
        var modal = document.getElementById(props.id)
        modal.classList.remove(`show`)
        var backdrop = document.getElementById(`modal-backdrop`)
        backdrop.classList.remove(`show`)
        document.body.classList.remove(`modal-open`)
        document.body.style.overflow = null
        document.body.style.paddingRight = null
        setTimeout(() => {
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-root'))
            backdrop.parentNode.removeChild(backdrop)
        }, 300)
    }

    useEffect(() => {
        document.body.className = "modal-open"
        document.body.style.overflow = "hidden"
        document.body.style.paddingRight = "0px"
        var check = (document.getElementById("modal-backdrop") === null) ? true : false
        if (check) {
            var backdrop = document.createElement("div")
            backdrop.id = "modal-backdrop"
            backdrop.className = "modal-backdrop fade"
            document.body.appendChild(backdrop)
        }
        document.getElementById(props.id).classList.add("d-block")
        setTimeout(() => {
            document.getElementById(props.id).classList.add("show")
            if (check) {
                backdrop.classList.add("show")
            }
        }, 200)
    }, [props])

    return (
        <div className="modal fade" id={props.id} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content min-height-90vh">
                    <div className="modal-header border-bottom-0 bg-warning">
                        <h6 className="modal-title">{props.title}</h6>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body bg-sky border-bottom border-top">
                        <form id="form-data" autoComplete="off">
                            <div className="row g-4">
                                <div className="col-12">
                                    <label className="form-label">Course Code <b className="text-danger">*</b></label>
                                    <input type="text" className="form-control" name="code" value={data.code} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} required />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Session Number <b className="text-danger">*</b></label>
                                    <input type="text" className="form-control" name="session" value={data.session} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} required />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">ชื่อหลักสูตร <b className="text-danger">*</b></label>
                                    <input type="text" className="form-control" name="title" value={data.title} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} required />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">สถานที่ <b className="text-danger">*</b></label>
                                    <input type="text" className="form-control" name="place" value={data.place} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} required />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">วันที่อบรม <b className="text-danger">*</b></label>
                                    <InputDateTime name="date" value={data.date} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} showTimeSelect={false} dateFormat="dd/MM/yyyy" required={true} />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">หมายเหตุ</label>
                                    <input type="text" className="form-control" name="note" value={data.note} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer border-top-0">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>ยกเลิก</button>
                        <button type="button" className="btn btn-success" onClick={handleSubmit}><i className="bi bi-check-lg me-2"></i>บันทึก</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

Modal.defaultProps = {
    id: "newsModal",
    title: "เพิ่ม",
    data: {
        code: "",
        title: "",
        place: "",
        session: "",
        date: moment().format('DD/MM/YYYY'),
        note: "",
        amount: null
    }
}

export default Modal